/**
 * Demande une double validation avant suppression d'une vente planning.
 * @param {(options: object) => Promise<boolean>} ask
 */
export async function confirmVenteDelete(ask, clientLabel = 'cette vente') {
  const label = String(clientLabel ?? '').trim() || 'cette vente';

  const first = await ask({
    title: 'Supprimer la vente',
    message: `Supprimer la vente « ${label} » ?\n\nCette action est définitive et ne peut pas être annulée.`,
    confirmLabel: 'Continuer',
    confirmVariant: 'danger',
  });
  if (!first) return false;

  return ask({
    title: 'Confirmer la suppression',
    message: `Confirmez la suppression définitive de « ${label} ».`,
    confirmLabel: 'Supprimer',
    confirmVariant: 'danger',
    confirmIcon: 'mdi:delete-outline',
  });
}

/**
 * Double confirmation avant de retirer une ligne du suivi créa pub.
 * @param {(options: object) => Promise<boolean>} ask
 */
export async function confirmPubGraphisteDelete(ask, clientLabel = 'cette publicité') {
  const label = String(clientLabel ?? '').trim() || 'cette publicité';

  const first = await ask({
    title: 'Supprimer du suivi créa pub',
    message: `Retirer « ${label} » du suivi créa pub ?\n\nCette action est définitive : la publicité disparaîtra de cette liste.`,
    confirmLabel: 'Continuer',
    confirmVariant: 'danger',
  });
  if (!first) return false;

  return ask({
    title: 'Confirmer la suppression',
    message: `Confirmez le retrait définitif de « ${label} » du suivi créa pub.`,
    confirmLabel: 'Supprimer',
    confirmVariant: 'danger',
    confirmIcon: 'mdi:delete-outline',
  });
}

/**
 * Demande confirmation avant d'effacer le contenu d'un emplacement (la ligne reste).
 * @param {(options: object) => Promise<boolean>} ask
 */
export async function confirmVenteClear(ask, clientLabel = 'cet emplacement') {
  const label = String(clientLabel ?? '').trim() || 'cet emplacement';

  return ask({
    title: 'Effacer le contenu',
    message: `Effacer le contenu de « ${label} » ?\n\nLe client, le statut et le commercial seront vidés. L'emplacement sera conservé.`,
    confirmLabel: 'Effacer',
    confirmVariant: 'warning',
  });
}
